import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { GetQuery, PostQuery } from './Shared';

interface RunsheetAddDetailModalProps {
    scheduleId: number;
    showModal: boolean;
    hideModal(): void;
    save(unitNumber: string, rowVersionTimestamp: Uint8Array): void;
}

const RunsheetAddDetailModalData = (props: RunsheetAddDetailModalProps) => {
    const [loading, setLoading] = React.useState(true);
    const [unitNumber, setUnitNumber] = React.useState("");
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        if (props.scheduleId > 0 && props.showModal) {
            getData();
        }
    }, [props.scheduleId]);

    const getData = async () => {
        const apiUrl = "GetJobUnitNumber?ScheduleId=" + props.scheduleId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setUnitNumber(result.data.unitNumber);
            setLoading(false);
        }
    }

    const validate = () => {
        var formIsValid = true;
        let errorList: any = {};

        //remove spaces, fullstops and spaces
        var unitToCheck = unitNumber.replace(/[.,\s]/g, '');
        if (unitToCheck.length < 4) {
            formIsValid = false;
            errorList["unitNumber"] = "Unit Number must be at least 4 characters (no spaces, fullstops, commas)!";
        }

        setErrors(errorList);
        setUnitNumber(unitToCheck);
        return formIsValid;
    }
    

    const saveModal = () => {
        var formIsValid = validate();
        if (formIsValid) {
            saveJobDetails();
        } else {
            toast.error("Enter unit number (at least 4 characters) before saving!");
        }
    }

    const saveJobDetails = async () => {
        var data = {
            scheduleId: props.scheduleId,
            unitNumber: unitNumber
        };

        var jsonItem = JSON.stringify(data);

        const apiUrl = "SaveJobUnitNumber";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving unit number!");
        } else {
            toast.success("Job updated successfully");
            props.save(unitNumber, result.data.rowVersionTimestamp);
        }
    }

    return (
        <Modal static size={'lg'} aria-labelledby="contained-modal-title-sm" show={props.showModal} onHide={props.hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Update Job Details</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div className={loading ? "hidden" : "" }>
                    <label className="input-group" htmlFor="unitNumber">
                        <span className="label">Unit Number</span>
                        <input className="input" type="text" maxLength={50} id="unitNumber" name="unitNumber" value={unitNumber} onChange={(e) => setUnitNumber(e.target.value)}></input>
                    </label>
                    <span className={errors["unitNumber"] ? "label errors marginLeft5" : "hidden"}>{errors["unitNumber"]}</span>
                </div>
                <div className={loading ? "" : "hidden"}>Loading...</div>
            </Modal.Body>

            <Modal.Footer>
                <button className="popup-button--yes" onClick={saveModal}>Save</button>
            </Modal.Footer>
        </Modal>
    );

}

export default RunsheetAddDetailModalData;